import api from "./api";

const route = "/checkout";

const CheckoutService = {
  attempt: (class_package_id, discountCode, payment_method) =>
    api.post(`${route}/attempt`, {
      class_package_id,
      discountCode,
      payment_method,
    }),
  postCheckout: (class_package_id, discountCode, payment_source_id) =>
    api.post(`${route}/attempt`, {
      class_package_id,
      payment_source_id,
      discountCode,
    }),
  postPayPal: (class_package_id, discountCode) =>
    api.post(`${route}/paypal`, { class_package_id, discountCode }),
  capturePayPal: ({ orderID }) => api.post(`${route}/capture`, { orderID }),
};

export default CheckoutService;
